import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalMessageService, TranslationService, UserAddressService, TranslatePipe } from '@spartacus/core';
import { LaunchDialogService, FormErrorsComponent } from '@spartacus/storefront';
import { AddressFormComponent } from '@spartacus/user/profile/components';
import { UserProfileFacade } from '@spartacus/user/profile/root';
import { Subscription } from 'rxjs';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'knbr-address-form',
    templateUrl: './kn-br-address-form.component.html',
    styleUrls: ['./kn-br-address-form.component.scss'],
    imports: [ReactiveFormsModule, FormErrorsComponent, NgSelectComponent, AsyncPipe, TranslatePipe]
})
export class KnBrAddressFormComponent extends AddressFormComponent implements OnInit, OnDestroy {
  defaultCountrySelected = 'US';
  addressForm: FormGroup = this.fb.group({
    country: this.fb.group({
      isocode: [this.defaultCountrySelected, Validators.required],
    }),
    firstName: ['', Validators.required],
    bldg: [''],
    houseNumber: [''],
    line1: ['', Validators.required],
    line2: [''],
    town: ['', Validators.required],
    region: this.fb.group({
      isocode: [null, Validators.required],
    }),
    postalCode: ['', Validators.required],
    phone: [''],
    defaultAddress: [false],
    email: [''],
    fax: [''],
    visibleInAddressBook: [true],
  });
  isCheckOut = false;
  submitAddressSubscribe: Subscription;
  constructor(
    protected fb: FormBuilder,
    // protected checkoutDeliveryService: CheckoutDeliveryFacade,
    protected userProfileFacade: UserProfileFacade,
    protected userAddressService: UserAddressService,
    protected globalMessageService: GlobalMessageService,
    protected modalService: LaunchDialogService,
    protected translation: TranslationService,
    public activeModal: NgbActiveModal
  ) {
    super(fb, userAddressService, globalMessageService, translation, modalService,userProfileFacade,);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.selectedCountry$.next(this.defaultCountrySelected);
    this.submitAddressSubscribe = this.submitAddress.asObservable().subscribe((res) => {
      if (this.activeModal) {
        const addrobj = {
          address: this.addressForm.value,
          isOneTime: false,
        };
        this.activeModal.close(addrobj);
      }
    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.submitAddressSubscribe) {
      this.submitAddressSubscribe.unsubscribe();
    }
  }

  oneTimeUse() {
    if (this.addressForm.valid) {
      const addrobj = {
        address: this.addressForm.value,
        isOneTime: true,
      };
      this.activeModal.close(addrobj);
    } else {
      this.addressForm.markAllAsTouched();
    }
  }
}
